/** @file SheetDialogs: whichever sheet dialog is due: split, overpaint, guide, or the fill result. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { ReactElement } from 'react';
import { BulkResultDialog } from '../BulkResultDialog';
import { GuideSheetDialog } from './GuideSheetDialog';
import { OverpaintDialog } from './OverpaintDialog';
import { SplitSheetDialog } from './SplitSheetDialog';
import type { SheetImport } from './useSheetImport';

/** The sheet flow, the open puppet, and the guide-mode brief copy. */
export type SheetDialogsProps = { sheets: SheetImport; puppet: Puppet; onCopyGuideBrief: () => void };

/** One dialog at a time; the fill result reuses the bulk upload's result dialog. */
export function SheetDialogs({ sheets, puppet, onCopyGuideBrief }: SheetDialogsProps): ReactElement | null {
  const fill = (cuts: Parameters<SheetImport['fill']>[0]): void => { void sheets.fill(cuts); };
  if (sheets.split !== null) return <SplitSheetDialog split={sheets.split} puppet={puppet} busy={sheets.busy} onFill={fill} onClose={sheets.close} />;
  if (sheets.overpaint !== null) return <OverpaintDialog overpaint={sheets.overpaint} loadGuide={sheets.loadGuide} busy={sheets.busy} onFill={fill} onClose={sheets.close} />;
  if (sheets.guideOpen) return <GuideSheetDialog loadGuide={sheets.loadGuide} onCopyBrief={onCopyGuideBrief} onClose={sheets.close} />;
  return sheets.result === null ? null : <BulkResultDialog outcome={sheets.result} onClose={sheets.closeResult} />;
}
